// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3SYvT","label":"Category_label__3t6nR","content":"Category_content__3Lj7J","header":"Category_header__2hqxH","location":"Category_location__2x2AC"};